import { ApiHelper } from "../heplers/APIHelper";
const apiHelper = new ApiHelper({ isPublic: true });

export const getSearchSuggestions = (lowerLimit: number = 0, upperLimit: number = 10, searchText: string) => {
  return apiHelper.get("master-search/getSuggestions", { lowerLimit, upperLimit, searchText });
};

export const getAllSearchResults = (
  lowerLimit: number = 0,
  upperLimit: number = 10,
  searchText: string,
  videotype?: any,
  duration?: any,
  uploadTime?: any
) => {
  const params: any = { lowerLimit, upperLimit, searchText, videotype, duration, uploadTime };

  // if (filterParam) {
  //   if (filterParam.videotype) params.videotype = filterParam.videotype;
  //   else if (filterParam.duration) params.duration = filterParam.duration;
  //   else if (filterParam.uploadTime) params.uploadTime = filterParam.uploadTime;
  // }

  return apiHelper.get("master-search/searchAll", params);
};
